import parseJSONP from "../utils/parseJSONP";

const GUID = import.meta.env.ABR_TOKEN || "4f94b581-a15b-4345-967c-b349343a23e6";

export async function getBusinessByABN(searchTerm) {
  try {
    const url = new URL("https://abr.business.gov.au/json/AbnDetails.aspx");
    url.searchParams.set("guid", GUID);
    url.searchParams.set("abn", searchTerm);

    const response = await fetch(url);
    if (!response.ok) throw new Error(`ABN lookup failed: ${response.status}`);
    return parseJSONP(await response.text());
  } catch (error) {
    console.error(error);
  }
}

export async function getBusinessByACN(searchTerm) {
  try {
    const url = new URL("https://abr.business.gov.au/json/AcnDetails.aspx");
    url.searchParams.set("guid", GUID);
    url.searchParams.set("acn", searchTerm);

    const response = await fetch(url);
    if (!response.ok) throw new Error(`ACN lookup failed: ${response.status}`);
    return parseJSONP(await response.text());
  } catch (error) {
    console.error(error);
  }
}

export async function getBusinessByName(searchTerm) {
  try {
    const url = new URL("https://abr.business.gov.au/json/MatchingNames.aspx");
    url.searchParams.set("guid", GUID);
    url.searchParams.set("name", searchTerm);

    const response = await fetch(url);
    if (!response.ok) throw new Error(`Name lookup failed: ${response.status}`);
    return parseJSONP(await response.text());
  } catch (error) {
    console.error(error);
  }
}
